import React, { useEffect, useState } from 'react';
import { checkMot } from '../../../../../../../ressources/functionJS/checkMot';
import * as glossaire_pattern from '../../../../../../../ressources/glossaires/glossaire_pattern';
import * as s from '../../../../../../../ressources/StyleGlobal/StyleGlobal';
import FormulaireSelectionDateHeureUnix from '../FormulaireSelectionDateHeureUnix/FormulaireSelectionDateHeureUnix';
import styles from './FormulaireAxe.module.scss';

const FormulaireAxe = ({
  preConfigAxe,
  axisName,
  disabled,
  gererConfigAxe,
}) => {
  const [title, setTitle] = useState('');
  const [type, setType] = useState('linear');
  const [range, setRange] = useState([null, null]);

  useEffect(() => {
    if (preConfigAxe !== undefined) {
      setTitle(preConfigAxe.title);
      setType(preConfigAxe.type);
      setRange([...preConfigAxe.range]);
    }
  }, [preConfigAxe]);

  useEffect(() => {
    const currentState = { title, type, range };
    gererConfigAxe(axisName, currentState);
  }, [title, type, range, axisName, gererConfigAxe]);

  const gererEtatDeCibleName = (event) => {
    setTitle(event.target.value);
  };

  const gererMinAxe = (event) => {
    setRange([parseFloat(event.target.value), range[1]]);
  };

  const gererMaxAxe = (event) => {
    setRange([range[0], parseFloat(event.target.value)]);
  };

  const gererMinAxeDate = (unix) => {
    setRange([parseInt(unix), range[1]]);
  };

  const gererMaxAxeDate = (unix) => {
    setRange([range[0], parseInt(unix)]);
  };

  const renderFormulairePlageDeLAxe = () => {
    switch (type) {
      case 'date':
        return (
          <>
            <div className={[styles.style, s.text_left].join(' ')}>
              {checkMot('config_pour_x_t')}
            </div>
            <div className={[styles.style, s.text_left].join(' ')}>
              {checkMot('plage_de_donnees_x_min_max')}
            </div>
            <div className={s.row}>
              <div className={s.col_6}>
                <FormulaireSelectionDateHeureUnix
                  value={range[0]}
                  gereUnixDate={gererMinAxeDate}
                  disabled={disabled === true}
                />
              </div>
              <div className={s.col_6}>
                <FormulaireSelectionDateHeureUnix
                  value={range[1]}
                  gereUnixDate={gererMaxAxeDate}
                  disabled={disabled === true}
                />
              </div>
            </div>
          </>
        );

      case 'linear':
        return (
          <>
            <div className={[styles.style, s.text_left].join(' ')}>
              {checkMot('plage_de')}
              {axisName}
            </div>
            <div className={s.row}>
              <div className={s.col_6}>
                <input
                  type="text"
                  pattern={glossaire_pattern.float}
                  className={[s.form_control, styles.input].join(' ')}
                  placeholder={
                    preConfigAxe?.range?.[0] === undefined
                      ? preConfigAxe?.range?.[0]
                      : 'echelle_de_l_axe_gauche_mim'
                  }
                  disabled={disabled === true}
                  value={range[0] || ''}
                  onChange={gererMinAxe}
                />
              </div>
              <div className={s.col_6}>
                <input
                  type="text"
                  pattern={glossaire_pattern.float}
                  className={[s.form_control, styles.input].join(' ')}
                  placeholder={
                    preConfigAxe?.range?.[1] === null
                      ? preConfigAxe?.range?.[1]
                      : 'echelle_de_l_axe_gauche_max'
                  }
                  disabled={disabled === true}
                  value={range[1] || ''}
                  onChange={gererMaxAxe}
                />
              </div>
            </div>
          </>
        );

      default:
        return (
          <div className={[styles.style, s.text_left].join(' ')}>
            {checkMot('selectionner_un_type_de_courbe')}
          </div>
        );
    }
  };

  return (
    <>
      <div className={[styles.style, s.text_left].join(' ')}>{axisName}</div>
      <div className={[styles.style, s.text_left].join(' ')}>
        {checkMot('titre')}
      </div>
      <input
        type="text"
        pattern="[0-9a-zA-Z._%+-]+"
        className={[s.form_control].join(' ')}
        placeholder="title"
        name="title"
        value={title}
        disabled={disabled === true}
        onChange={gererEtatDeCibleName}
      />
      {renderFormulairePlageDeLAxe()}
    </>
  );
};

export default FormulaireAxe;
